// src/config.js
// Use environment variables or defaults
const API_BASE_URL = process.env.REACT_APP_API_BASE_URL || "http://localhost:81"; // For ratings-backRate
const API_AUTH_URL = process.env.REACT_APP_API_AUTH_URL || "http://localhost:80"; // For login-backRate
const API_LLM_URL = process.env.REACT_APP_CHATBOT_API_URL || "http://localhost:3003"; // For llmRate
const PREVIEW_BASE_URL = process.env.REACT_APP_URL || "http://app.tritutech.com"; // For frontRate preview

export const API_URLS = {
  // Auth endpoints (login-backRate)
  login: `${API_AUTH_URL}/api/auth/login`,
  registerBusiness: `${API_AUTH_URL}/api/business/register`, // This handles user+business creation initially
  verifyToken: `${API_AUTH_URL}/api/auth/verify-token`,
  logout: `${API_AUTH_URL}/api/auth/logout`,    // add logout
  passwordResetRequest: `${API_AUTH_URL}/api/auth/password-reset-request`,
  verifyResetCode: `${API_AUTH_URL}/api/auth/verify-reset-code`,
  resetPassword: `${API_AUTH_URL}/api/auth/reset-password`,
  updateAccount: `${API_AUTH_URL}/api/auth/account`, // Endpoint for updating user details like name/email/password
  updatePassword: `${API_AUTH_URL}/api/auth/password`, // Endpoint for changing password

  // Settings endpoints
  // Business Info (PUT, for name and image upload)
  businessInfo: businessId => `${API_AUTH_URL}/api/business/${businessId}/business-info`,

  // Branding settings (GET)
  branding: businessId => `${API_BASE_URL}/api/content/${businessId}/branding`, // Existing endpoint can be used for GET/PUT
  // Branding settings (PUT)
  uploadBusinessImages: businessId => `${API_BASE_URL}/api/content/${businessId}/upload`, // Example: Define a specific route
  // Other settings
  questions: businessId => `${API_BASE_URL}/api/content/${businessId}/questions`, // Existing endpoint can be used for GET/PUT
  referralLinks: businessId => `${API_BASE_URL}/api/content/${businessId}/referrals`, // Existing endpoint can be used for GET/PUT
  appearanceSettings: businessId => `${API_BASE_URL}/api/content/${businessId}/appearance`,
  template: businessId => `${API_BASE_URL}/api/content/${businessId}/template`, // Template settings endpoint

  // Chatbot endpoint (llmRate)
  chatbot: businessId => `${API_LLM_URL}/api/${businessId}/llm/chat`, // Updated based on llmRate setup
  // Analytics endpoints (ratings-backRate) - Add if needed for dashboard
  overview: businessId => `${API_BASE_URL}/api/analytics/${businessId}/overview`,
  timeSeries: businessId => `${API_BASE_URL}/api/analytics/${businessId}/time-series`, // Added time-series endpoint
  topics: businessId => `${API_BASE_URL}/api/analytics/${businessId}/topics`,
  textFeedback: businessId => `${API_BASE_URL}/api/analytics/${businessId}/feedback`,
  topThemes: businessId => `${API_BASE_URL}/api/analytics/${businessId}/top-themes`, // Add top themes endpoint
  refreshAnalytics: businessId => `${API_BASE_URL}/api/analytics/${businessId}/refresh`,
  exportAnalytics: businessId => `${API_BASE_URL}/api/analytics/${businessId}/export`,
  feedbackSession: (businessId, submissionId) => `${API_BASE_URL}/api/analytics/${businessId}/feedback-session/${submissionId}`,
};

// Preview configuration
export const PREVIEW_CONFIG = {
  baseUrl: PREVIEW_BASE_URL,
  previewUrl: (businessId, previewPage = '') => 
    `${PREVIEW_BASE_URL}/app/${businessId}/${previewPage}?preview=true`,
  allowedOrigin: PREVIEW_BASE_URL
};